export class ProgressRail extends HTMLElement {
  connectedCallback(): void {
    this.render();
  }

  setProgress(current: number, total: number): void {
    const safeTotal = Math.max(total, 1);
    const pct = Math.min(100, Math.max(0, (current / safeTotal) * 100));
    this.style.setProperty('--progress', `${pct}%`);
    this.setAttribute('aria-valuemin', '0');
    this.setAttribute('aria-valuemax', String(total));
    this.setAttribute('aria-valuenow', String(current));
    this.setAttribute('role', 'progressbar');
    const fill = this.querySelector<HTMLElement>('.fill');
    if (fill) fill.style.inlineSize = `${pct}%`;
  }

  private render(): void {
    if (this.querySelector('.track')) return;
    this.innerHTML = '<div class="track" aria-hidden="true"><div class="fill" style="inline-size: var(--progress, 0%)"></div></div>';
  }
}

customElements.define('progress-rail', ProgressRail);
